import type { AnalyticsHistoryWindow, MarketInterval } from "@/api/hip3";

export const DEFAULT_OVERVIEW_WINDOW: AnalyticsHistoryWindow = "30d";
export const DEFAULT_OVERVIEW_INTERVAL: MarketInterval = "4h";

const historyWindows: AnalyticsHistoryWindow[] = ["1d", "7d", "30d"];
const marketIntervals: MarketInterval[] = ["5m", "1h", "4h", "1d"];

export function isAnalyticsHistoryWindow(value: string | null): value is AnalyticsHistoryWindow {
  return value != null && historyWindows.includes(value as AnalyticsHistoryWindow);
}

export function isMarketInterval(value: string | null): value is MarketInterval {
  return value != null && marketIntervals.includes(value as MarketInterval);
}

export function normalizeOverviewInterval(
  window: AnalyticsHistoryWindow,
  interval: MarketInterval
): MarketInterval {
  if (window === "30d" && (interval === "1h" || interval === "5m")) return "4h";
  if (window === "7d" && interval === "5m") return "1h";
  return interval;
}

export function overviewIntervalOptions(window: AnalyticsHistoryWindow): MarketInterval[] {
  if (window === "1d") return ["5m", "1h", "4h", "1d"];
  if (window === "7d") return ["1h", "4h", "1d"];
  return ["4h", "1d"];
}

export function sanitizeOverviewHistoryParams(rawWindow: string | null, rawInterval: string | null): {
  window: AnalyticsHistoryWindow;
  interval: MarketInterval;
  changed: boolean;
} {
  const window = isAnalyticsHistoryWindow(rawWindow) ? rawWindow : DEFAULT_OVERVIEW_WINDOW;
  const requestedInterval = isMarketInterval(rawInterval) ? rawInterval : DEFAULT_OVERVIEW_INTERVAL;
  const interval = normalizeOverviewInterval(window, requestedInterval);
  const changed = window !== rawWindow || interval !== rawInterval;

  return { window, interval, changed };
}
